// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Self-contained styles for A11y violation list items. */

.a11y-violation-item {
  border-bottom: 1px solid #e5e7eb;
  padding: 8px 0;
}

.a11y-violation-trigger {
  width: 100%;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  text-align: left;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.a11y-violation-trigger:hover .a11y-violation-id {
  text-decoration: underline;
}

.a11y-violation-badge-row {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}

.a11y-violation-badge {
  font-size: 10px;
  font-weight: 700;
  padding: 2px 6px;
  border-radius: 3px;
  text-transform: uppercase;
  letter-spacing: 0.05ch;
  flex-shrink: 0;
}

.a11y-violation-id {
  font-size: 12px;
  font-weight: 600;
  color: #111827;
}

.a11y-violation-count {
  margin-left: auto;
  font-size: 11px;
  color: #6b7280;
  flex-shrink: 0;
}

.a11y-violation-description {
  font-size: 11px;
  line-height: 1.4;
  color: #4b5563;
}

.a11y-wcag-tags {
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
}

.a11y-wcag-tag {
  font-size: 10px;
  padding: 1px 5px;
  border-radius: 3px;
  background: #f3f4f6;
  color: #374151;
  font-family: monospace;
}

.a11y-learn-more {
  display: inline-block;
  margin-top: 2px;
  font-size: 10px;
  color: #2563eb;
  text-decoration: underline;
}

/* Per-rule authoring guidance note. */
.a11y-authoring-hint {
  margin: 6px 0 0;
  padding: 6px 8px;
  font-size: 11px;
  line-height: 1.45;
  color: #374151;
  background: #eff6ff;
  border-left: 3px solid #2563eb;
  border-radius: 3px;
}

.a11y-node-list {
  margin-top: 6px;
  padding-left: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.a11y-node-item {
  padding-left: 8px;
}

.a11y-node-item-header {
  display: flex;
  align-items: flex-start;
  gap: 4px;
}

.a11y-node-item-header .a11y-node-selector {
  flex: 1;
  min-width: 0;
}

.a11y-node-jump-btn {
  flex-shrink: 0;
  background: none;
  border: 1px solid #d1d5db;
  border-radius: 3px;
  padding: 1px 5px;
  cursor: pointer;
  font-size: 11px;
  color: #6b7280;
  line-height: 1.4;
}

.a11y-node-jump-btn:hover {
  background: #f3f4f6;
  color: #111827;
  border-color: #9ca3af;
}

.a11y-node-selector {
  font-size: 10px;
  background: #f3f4f6;
  padding: 2px 4px;
  border-radius: 3px;
  word-break: break-all;
  display: block;
  color: #374151;
  font-family: monospace;
}

.a11y-fix-messages {
  margin: 3px 0 0;
  padding-left: 14px;
}

.a11y-fix-message {
  font-size: 11px;
  color: #6b7280;
  line-height: 1.4;
}

.a11y-fix-summary {
  font-size: 11px;
  color: #6b7280;
  margin: 3px 0 0;
  line-height: 1.4;
}
`, "",{"version":3,"sources":["webpack://./Scripts/Shared/AccessibilityChecker/styles/ViolationItem.css"],"names":[],"mappings":"AAAA,yDAAyD;;AAEzD;EACE,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,eAAe;EACf,cAAc;EACd,0BAA0B;AAC5B;;AAEA,sCAAsC;AACtC;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;EACd,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB","sourcesContent":["/* Self-contained styles for A11y violation list items. */\r\n\r\n.a11y-violation-item {\r\n  border-bottom: 1px solid #e5e7eb;\r\n  padding: 8px 0;\r\n}\r\n\r\n.a11y-violation-trigger {\r\n  width: 100%;\r\n  background: none;\r\n  border: none;\r\n  padding: 0;\r\n  cursor: pointer;\r\n  text-align: left;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 4px;\r\n}\r\n\r\n.a11y-violation-trigger:hover .a11y-violation-id {\r\n  text-decoration: underline;\r\n}\r\n\r\n.a11y-violation-badge-row {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.a11y-violation-badge {\r\n  font-size: 10px;\r\n  font-weight: 700;\r\n  padding: 2px 6px;\r\n  border-radius: 3px;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.05ch;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.a11y-violation-id {\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  color: #111827;\r\n}\r\n\r\n.a11y-violation-count {\r\n  margin-left: auto;\r\n  font-size: 11px;\r\n  color: #6b7280;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.a11y-violation-description {\r\n  font-size: 11px;\r\n  line-height: 1.4;\r\n  color: #4b5563;\r\n}\r\n\r\n.a11y-wcag-tags {\r\n  display: flex;\r\n  gap: 4px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.a11y-wcag-tag {\r\n  font-size: 10px;\r\n  padding: 1px 5px;\r\n  border-radius: 3px;\r\n  background: #f3f4f6;\r\n  color: #374151;\r\n  font-family: monospace;\r\n}\r\n\r\n.a11y-learn-more {\r\n  display: inline-block;\r\n  margin-top: 2px;\r\n  font-size: 10px;\r\n  color: #2563eb;\r\n  text-decoration: underline;\r\n}\r\n\r\n/* Per-rule authoring guidance note. */\r\n.a11y-authoring-hint {\r\n  margin: 6px 0 0;\r\n  padding: 6px 8px;\r\n  font-size: 11px;\r\n  line-height: 1.45;\r\n  color: #374151;\r\n  background: #eff6ff;\r\n  border-left: 3px solid #2563eb;\r\n  border-radius: 3px;\r\n}\r\n\r\n.a11y-node-list {\r\n  margin-top: 6px;\r\n  padding-left: 0;\r\n  list-style: none;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n}\r\n\r\n.a11y-node-item {\r\n  padding-left: 8px;\r\n}\r\n\r\n.a11y-node-item-header {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 4px;\r\n}\r\n\r\n.a11y-node-item-header .a11y-node-selector {\r\n  flex: 1;\r\n  min-width: 0;\r\n}\r\n\r\n.a11y-node-jump-btn {\r\n  flex-shrink: 0;\r\n  background: none;\r\n  border: 1px solid #d1d5db;\r\n  border-radius: 3px;\r\n  padding: 1px 5px;\r\n  cursor: pointer;\r\n  font-size: 11px;\r\n  color: #6b7280;\r\n  line-height: 1.4;\r\n}\r\n\r\n.a11y-node-jump-btn:hover {\r\n  background: #f3f4f6;\r\n  color: #111827;\r\n  border-color: #9ca3af;\r\n}\r\n\r\n.a11y-node-selector {\r\n  font-size: 10px;\r\n  background: #f3f4f6;\r\n  padding: 2px 4px;\r\n  border-radius: 3px;\r\n  word-break: break-all;\r\n  display: block;\r\n  color: #374151;\r\n  font-family: monospace;\r\n}\r\n\r\n.a11y-fix-messages {\r\n  margin: 3px 0 0;\r\n  padding-left: 14px;\r\n}\r\n\r\n.a11y-fix-message {\r\n  font-size: 11px;\r\n  color: #6b7280;\r\n  line-height: 1.4;\r\n}\r\n\r\n.a11y-fix-summary {\r\n  font-size: 11px;\r\n  color: #6b7280;\r\n  margin: 3px 0 0;\r\n  line-height: 1.4;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
